import { useEffect } from 'react';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { listaHistoricoSolicitacoesApi } from '../api/ListaHistoricoSolicitacoesApi';
import { hasGestorSelecionado } from '../api/shared';
import type { ListaHistoricoSolicitacoesResponse } from '../types';

export function useListarHistoricoSolicitacoes(
  options?: Omit<UseQueryOptions<ListaHistoricoSolicitacoesResponse, Error>, 'queryKey' | 'queryFn'>
) {
  const { toast } = useToast();

  const query = useQuery<ListaHistoricoSolicitacoesResponse, Error>({
    queryKey: ['relatorios', 'historico-solicitacoes'],
    queryFn: listaHistoricoSolicitacoesApi,
    refetchOnWindowFocus: false,
    ...options,
    enabled: (options?.enabled ?? true) && hasGestorSelecionado(),
  });

  useEffect(() => {
    if (!query.error) return;
    toast({
      variant: 'destructive',
      title: 'Erro ao carregar histórico',
      description: 'Não foi possível carregar o histórico de solicitações.',
    });
  }, [query.error, toast]);

  return query;
}
